import * as types from "../api/types";

export default {
  state: {
    siteTypes: [],
    siteType: {}
  },
  mutations: {
    getSiteTypes(state, siteTypes) {
      state.siteTypes = siteTypes;
    },
    getSiteType(state, siteType) {
      state.siteType = siteType;
    }
  },
  actions: {
    async getSiteTypes({ commit }) {
      const data = await types.getSiteTypes();
      commit("getSiteTypes", data);
    },
    async getSiteType({ commit }, id) {
      const data = await types.getSiteType(id);
      commit("getSiteType", data);
    }
  }
};
